import React from 'react'
import { Step, StepLabel, Stepper, useMediaQuery } from '@material-ui/core'

import usePhishing from 'hooks/usePhishing'
import useStyles from './styles'
import theme from 'theme'
import constants from 'constants/index'

const PhishingStepper = () => {
  const { activeStep, handleStep, isCompleted, isReadOnly } = usePhishing()
  const classes = useStyles()
  const isLarge = useMediaQuery(theme.breakpoints.up('lg'))

  const steps = isReadOnly
    ? constants.phishing.FORM_STEPS_VIEW
    : constants.phishing.FORM_STEPS

  return (
    <Stepper
      activeStep={activeStep}
      orientation={isLarge ? 'horizontal' : 'vertical'}
    >
      {steps.map((label, index) => (
        <Step
          key={label}
          onClick={() => handleStep(index)}
          completed={isCompleted(index)}
          className={classes.stepper}
        >
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}

export default PhishingStepper
